import AwardsTable from 'components/awards/AwardsTable'
import React from 'react'
import PageContent from 'components/common/PageContent'

export default function Awards(props) {
    const pathElements = [
        {id: 0, title: "Home", url: "/"},
        {id: 1, title: "Awards"}
    ];

    return (
        <PageContent pathElements={pathElements} >
            <AwardsTable />
        </PageContent>
    );
}